import {
  STORE_APPLE_DATA
} from '../../constants/actions';

const initialState = {
  appleLoginData: {}
};

export default function appleData (state = initialState, action = {}) {
  switch (action.type) {
    case STORE_APPLE_DATA:
      return {
        ...state,
        appleLoginData: action.data
      };

    default:
      return state;
  }
}
